module.exports = __webpack_public_path__ + "ca00e8ce63dbf103b96113e08e31d8f9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-26.png
// module id = 1538
// module chunks = 0